import { render, staticRenderFns } from "./admin-delivery-actions.vue?vue&type=template&id=c9636142"
import script from "./admin-delivery-actions.vue?vue&type=script&lang=js"
export * from "./admin-delivery-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports